import { createPortal } from 'react-dom';

/**
 * InfoModal - 説明モーダル（共通）
 *
 * イラスト・ゲーム的な太枠スタイルのシンプルな説明モーダル。
 * ところどころの機能説明に再利用できる共通コンポーネント。
 *
 * Props:
 *   isOpen   - 表示/非表示
 *   onClose  - 閉じるボタン押下時のコールバック
 *   title    - モーダルタイトル
 *   children - 説明文など任意のコンテンツ
 *
 * メインカラーはプログレスバーに合わせて amber-400 (#FBBF24) 固定。
 * createPortal で document.body 直下にレンダリングし、
 * マップライブラリの cursor/pointer-event 干渉を完全に回避する。
 */

const MODAL_COLOR = '#FBBF24';
const MODAL_COLOR_DARK = '#D97706'; // タイトル文字・ボタン文字用（amber-600）

const InfoModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return createPortal(
    /* バックドロップ: document.body 直下にマウントしマップの干渉を排除 */
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center px-6"
      style={{ backgroundColor: 'rgba(0,0,0,0.45)', cursor: 'default' }}
      onPointerDown={onClose}
    >
      {/* モーダル本体（伝播を止める） */}
      <div
        className="relative w-full max-w-sm rounded-2xl bg-white px-6 pb-5 pt-5"
        style={{
          border: `4px solid ${MODAL_COLOR}`,
          boxShadow: `0 6px 0 ${MODAL_COLOR}`,
          cursor: 'default',
        }}
        onPointerDown={(e) => e.stopPropagation()}
      >
        {/* タイトル */}
        <p
          className="mb-3 text-center text-base font-extrabold"
          style={{ color: MODAL_COLOR_DARK }}
        >
          {title}
        </p>

        {/* 区切り線 */}
        <div
          className="mb-3 h-0.5 w-full rounded"
          style={{ backgroundColor: MODAL_COLOR, opacity: 0.4 }}
        />

        {/* コンテンツ */}
        <div className="text-sm leading-relaxed text-gray-700">
          {children}
        </div>

        {/* 閉じるボタン */}
        <button
          onPointerDown={(e) => { e.stopPropagation(); onClose(); }}
          className="mt-5 w-full rounded-xl py-2.5 text-sm font-bold text-white transition-opacity active:opacity-80"
          style={{ backgroundColor: MODAL_COLOR_DARK }}
        >
          閉じる
        </button>
      </div>
    </div>,
    document.body
  );
};

export default InfoModal;
